import React from "react";

import { useField } from "formik";

import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

import { getDate } from "@ip-utils";

import { Loader } from "../../index";
import Base from "./Base";

export default function Date({
  loading,
  name = "date",
  required,
  timeEndOfDay,
  timeStartOfDay,
  ...props
}) {
  const [, , helpers] = useField(name);

  function getValue(value) {
    const date = getDate(value);
    if (date) {
      if (timeStartOfDay) {
        return date.startOf("day");
      } else if (timeEndOfDay) {
        date.endOf("day");
        const now = getDate();
        return date.isAfter(now) ? now : date;
      }
    }
    return date;
  }

  const field = (fieldProps) => (
    <Loader loading={loading} overlay>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          {...fieldProps}
          autoOk
          clearable={!required}
          format="dd/MM/yyyy"
          inputVariant="outlined"
          onChange={(date) => helpers.setValue(getValue(date), false)}
        />
      </MuiPickersUtilsProvider>
    </Loader>
  );

  return <Base as={field} name={name} required={required} {...props} />;
}
